import React from "react";

import { FiUser } from "react-icons/fi";
import FwDropdown from "../components/FwDropdown";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const ReferenceDetailsPage = ({
  references,
  activeReferenceTab,
  setActiveReferenceTab,

  updateReference,

  REFERENCE_RELATIONS,

  openDropdown,
  setOpenDropdown,

  referenceError,

  proceedReference,

  setReferenceError,
  setScreen,
}) => {
  return (
    <section className="fw-screen fw-screen--form fw-screen--reference fw-fade">
           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      <h1 className="fw-title">
        Reference Details 
      </h1>

      <p className="fw-sub fw-reference__sub">
        Please provide verified references for
        documentation purposes.
      </p>

      <div className="fw-ref-tabs">
        {[0, 1].map((index) => (
          <button
            key={index}
            type="button"
            className={`fw-ref-tab ${
              activeReferenceTab === index
                ? "is-active"
                : ""
            }`}
            onClick={() => {
              setActiveReferenceTab(index);
              setReferenceError("");
            }}
          >
            <FiUser />
            Reference {index + 1}
          </button>
        ))}
      </div>

      <div className="fw-reference__form">
        <label className="fw-field">
          <span>Reference Name</span>

          <input
            value={
              references[activeReferenceTab].name
            }
            placeholder="Joey Tribbiani"
            onChange={(e) =>
              updateReference(
                activeReferenceTab,
                "name",
                e.target.value
              )
            }
          />
        </label>

        <label className="fw-field">
          <span>Mobile Number</span>

          <input
            type="tel"
            inputMode="numeric"
            maxLength={10}
            value={
              references[activeReferenceTab].mobile
            }
            placeholder="eg. 9864437856"
            onChange={(e) =>
              updateReference(
                activeReferenceTab,
                "mobile",
                e.target.value
                  .replace(/\D/g, "")
                  .slice(0, 10)
              )
            }
          />
        </label>

        <FwDropdown
          id={`relation-${activeReferenceTab}`}
          label="Relation"
          value={
            references[activeReferenceTab].relation
          }
          placeholder="Select relation"
          options={REFERENCE_RELATIONS}
          openKey={openDropdown}
          setOpenKey={setOpenDropdown}
          onChange={(val) =>
            updateReference(
              activeReferenceTab,
              "relation",
              val
            )
          }
        />

        {referenceError && (
          <p className="fw-error">
            {referenceError}
          </p>
        )}
      </div>

      <div className="fw-actions">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={() => {
            if (activeReferenceTab === 1) {
              setActiveReferenceTab(0);
              setReferenceError("");
              return;
            }

            setScreen("/apply-new/approved");
          }}
        >
          Back
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--primary"
          onClick={proceedReference}
        >
          Proceed
        </button>
      </div>
    </section>
  );
};

export default ReferenceDetailsPage;